import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { Loader2 } from 'lucide-react';
import AppFooter from '../components/AppFooter';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleCallback } = useAuth();
  const { language } = useLanguage();
  const tr = (en: string, ka: string) => (language === 'ka' ? ka : en);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const returnedState = params.get('state');

      const savedState = sessionStorage.getItem('oauth_state');
      sessionStorage.removeItem('oauth_state');

      if (code && savedState && returnedState === savedState) {
        try {
          const user = await handleGoogleCallback(code);
          window.history.replaceState(null, '', '/dashboard');
          navigate('/dashboard', { replace: true, state: { user } });
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [location, handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen bg-story-gradient flex flex-col">
      <div className="relative z-10 flex-1 flex flex-col">
        <div className="flex-1 flex items-center justify-center">
          <div className="glass-panel motion-safe:animate-pop-in rounded-bubble-lg px-10 py-12 text-center">
            <div className="w-16 h-16 rounded-2xl btn-gradient flex items-center justify-center mx-auto mb-5">
              <Loader2 className="w-8 h-8 animate-spin text-white" />
            </div>
            <p className="text-[#4a3d66] dark:text-[#c3b8dd] font-medium">{tr('Signing you in...', 'მიმდინარეობს შესვლა...')}</p>
          </div>
        </div>
        <AppFooter maxWidth="max-w-md" bordered={false} />
      </div>
    </div>
  );
};

export default AuthCallback;
